module.exports = __webpack_public_path__ + "static/media/wedding-catering-9.85748e5f.jpg";